import { Container } from 'react-bootstrap'

export const banner = {
    bgimg: {
        backgroundImage: `url(${require('../images/banner-img.jpg')})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    title: "Safeguarding Your Digital Frontier",
    btn: "Start for Free",
    leftdetail: "Scan your first 25 targets per month for free!",
    rightdetail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat. Praesent fringilla rutrum massa eu malesuada. ",
    bannerimg: require('../images/banner-bottom-img.jpg'),
    bannerimgmobile: require('../images/banner-bottom-img-mobile.jpg'),
    alt: "banner img",
    contents: [
        {
            subTitle: "Benefit 1",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat."
        },
        {
            subTitle: "Benefit 2",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat."
        },
        {
            subTitle: "Benefit 3",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat."
        }
    ]
}

export const features = {
    subtitle: 'Key Features',
    sectiontitle: 'Empowering Protection',
    items: [
        {
            icon: require('../images/feature-icon.svg').default,
            alt: "Feature 1",
            title: "Feature Name",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat. "
        },
        {
            icon: require('../images/feature-icon.svg').default,
            alt: "Feature 2",
            title: "Feature Name 1",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat. "
        },
        {
            icon: require('../images/feature-icon.svg').default,
            alt: "Feature 2",
            title: "Feature Name 2",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat. "
        },
        {
            icon: require('../images/feature-icon.svg').default,
            alt: "Feature 2",
            title: "Feature Name 3",
            detail: "Aenean sagittis ex a tellus placerat, sit amet posuere risus tincidunt. Nulla mauris augue, viverra nec libero nec, vehicula commodo erat. "
        },
    ]
}

export const video = {
    subtitle: 'Video Demo',
    sectiontitle: 'See SpeedScan in Action',  
    videoimg: require('../images/banner-bottom-img.jpg'),
    alt: "Video img",
    playicon: require('../images/play-icon.svg').default,
    blocktitle: 'Start securing your data with SpeedScan today!',
    btn: 'Start for free',
    videoSrc: require('../images/Speedscan-video.mp4'),
}

export const about = {
    subtitle: 'About Us',
    sectiontitle: 'Unveiling SpeedScan',
    details: [
        "Etiam maximus aliquet massa, vitae dignissim tortor imperdiet at. Mauris dictum eu urna in ornare. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Quisque rutrum lorem sit amet lectus volutpat dictum.",
        "Donec varius, turpis in molestie suscipit, mi libero vulputate velit, sed gravida tortor mauris ac massa. Donec tellus felis, pellentesque at condimentum et, mattis non ante. ",
    ],
    aboutimg: require('../images/about-img.png'),
    alt: "about img",
    aboutbg: require('../images/about-bg.svg').default,
    aboutbgmobile: require('../images/about-bg-mobile.svg').default,
}

export const reviews = {
    subtitle: 'Reviews',
    sectiontitle: 'What Our Customers Are Saying',
    items: [
        {
            detail: 'Etiam maximus aliquet massa, vitae dignissim tortor imperdiet at. Mauris dictum eu urna in ornare. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Quisque rutrum lorem sit amet lectus volutpat dictum.',
            img: require('../images/john-smith.jpg'),
            alt: 'john-smith',
            name: 'John Smith',
            text: 'from',
            logo: require('../images/dummy-logo.svg').default,
            rating: 5 // Rating out of 5

        },
        {
            detail: 'Etiam maximus aliquet massa, vitae dignissim tortor imperdiet at. Mauris dictum eu urna in ornare. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Quisque rutrum lorem sit amet lectus volutpat dictum.',
            img: require('../images/john-smith.jpg'),
            alt: 'john-smith',
            name: 'John Smith 1',
            text: 'from',
            logo: require('../images/dummy-logo.svg').default,
            rating: 4 // Rating out of 5

        },
        {
            detail: 'Etiam maximus aliquet massa, vitae dignissim tortor imperdiet at. Mauris dictum eu urna in ornare. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Quisque rutrum lorem sit amet lectus volutpat dictum.',
            img: require('../images/john-smith.jpg'),
            alt: 'john-smith',
            name: 'John Smith 2',
            text: 'from',
            logo: require('../images/dummy-logo.svg').default,
            rating: 3 // Rating out of 5

        },
    ],
}
export const plans = {
    planssubtitle: 'Plans',
    planssectiontitle: 'Tailored Protection for Your Cybersecurity Needs',
}

export const scan = {
    bgimg: {
        backgroundImage: `url(${require("../images/scanbg.png")})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
    },
    scantitle: `Scan Your First 25 Targets
Per Month For Free`,
    scanbtn: 'Start for Free',
};

export const footer = {
    footerlogo: require("../images/footerlogo.svg").default,
    alt: "logo",
    footerinfo:
        "Etiam maximus aliquet massa, vitae dignissim tortor imperdiet at. Mauris dictum eu urna in ornare.",
    footerlink1: "Features",
    footerlink2: "Demo Video",
    footerlink3: "About us",
    footerlink4: "Reviews",
    footerlink5: "Plans",
    emailinfo: "contact@speedscan.com",
};
